/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreatePostRequest, CreatePostState, Post } from "store/modules/posts/types";

const initialState: CreatePostState = {
    isRequesting: false,
    errors: []
};

const createPostSlice = createSlice({
    name: "posts@createPost",
    initialState,
    reducers: {
        createPostRequest: (
            state,
            action: PayloadAction<CreatePostRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        createPostSuccess: (
            state,
            action: PayloadAction<Post | undefined>
        ): void => {
            state.isRequesting = false;            
        },
        createPostFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    createPostFailed,
    createPostRequest,
    createPostSuccess
} = createPostSlice.actions;
export default createPostSlice.reducer;
